import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

// Views
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Dashboard from '../views/Dashboard.vue'
import InvoiceProcessor from '../views/InvoiceProcessor.vue'
import UserManagement from '../views/UserManagement.vue'
import Credits from '../views/Credits.vue'
import PurchaseCredits from '../views/PurchaseCredits.vue' // Added import

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { guest: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoice',
    name: 'InvoiceProcessor',
    component: InvoiceProcessor,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/credits',
    name: 'PurchaseCredits',
    component: PurchaseCredits,
    meta: { requiresAuth: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: { public: true }
  },
  {
    path: '/settings',
    name: 'UserSettings',
    component: () => import('../views/UserSettings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin-1973-06-28',
    name: 'AdminPanel',
    component: () => import('../views/AdminPanel.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isAuthenticated']
  const isAdmin = store.getters['auth/isAdmin']

  // Routes that require authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if (to.matched.some(record => record.meta.requiresAdmin) && !isAdmin) {
      next({ name: 'InvoiceProcessor' }) // Redirect non-admin users
    } else {
      next()
    }
  }
  // Routes for guests only (login, register)
  else if (to.matched.some(record => record.meta.guest)) {
    if (isLoggedIn) {
      next({ name: 'InvoiceProcessor' })
    } else {
      next()
    }
  }
  // Public routes
  else {
    next()
  }
})

export default router